import {AbstractApp} from "../app/AbstractApp";
import {DateUtils} from "../utils/DateUtils";

export class ErrorInfo {
    [key: string]: any;

    isUncaught: true | false = false;
    listener = '';
    message = '';

    stackTrace? = '';
    name? = '';
    date? = '';
    deviceModel? = '';
    deviceName? = '';
    deviceManufacturer? = '';
    deviceOSName? = '';
    deviceOSVersion? = '';
    deviceOSType? = '';
}

export class ErrorManager {

    readonly app: AbstractApp;

    private _isUncaughtErrorOccurred = false;
    private _onError: ((errorInfo: ErrorInfo) => void) | null = null;

    constructor(app: AbstractApp) {
        this.app = app;
    }

    get isUncaughtErrorOccurred() {
        return this._isUncaughtErrorOccurred;
    }

    public handleCaughtError(error: any, devMessage = '-') {
        const errorInfo: ErrorInfo = {
            isUncaught: false,
            listener: 'handleCaughtError',
            message: JSON.stringify(error) + ' DEV MESSAGE: ' + devMessage,
        };
        this.addDeviceInfoToReport(errorInfo);
        // Main.onUncaughtError(); не надо так как ошибка не существенна
        if (this._onError) {
            this._onError(errorInfo);
        }
    }

    private handleUncaughtError(errorInfo:ErrorInfo) {
        if (!this._isUncaughtErrorOccurred) {
            this._isUncaughtErrorOccurred = true;
            if (this._onError) {
                this._onError(errorInfo);
            }
        }
    }

    init(onError: (errorInfo: ErrorInfo) => void) {
        this._onError = onError;

        window.onerror = (message, source, lineno, colno, error) => {
            const errorInfo: ErrorInfo = {
                isUncaught: true,
                listener: 'window.onerror',
                name: error?.name || '',
                message: error?.message || message?.toString() || '',
                stackTrace: error?.stack || '',
            };
            this.addDeviceInfoToReport(errorInfo);
            this.handleUncaughtError(errorInfo);
            return true; // prevent crash
        };

        window.onunhandledrejection = ((event) => {
            const errorInfo: ErrorInfo = {
                isUncaught: true,
                listener: 'window.unhandledrejection',
                name: event.type,
                message: JSON.stringify(event.reason),
                stackTrace: '',
            };
            this.addDeviceInfoToReport(errorInfo);
            event.preventDefault(); // prevent crash
            this.handleUncaughtError(errorInfo);
        });
    }

    private addDeviceInfoToReport(data: ErrorInfo): void {
        if (!data) return;
        data.date = DateUtils.currentUTCDate.toLocaleDateString();
        data.deviceModel = this.app.device.deviceModel;
        data.deviceName = this.app.device.deviceName;
        data.deviceManufacturer = this.app.device.deviceManufacturer;
        data.deviceOSName = this.app.device.deviceOSName;
        data.deviceOSVersion = this.app.device.deviceOSVersion;
        data.deviceOSType = this.app.device.deviceOperatingSystem;
    }
}
